import React from "react";
import Box from "@mui/material/Box";
import { Typography } from "@mui/material";
import PageContainer from "./PageContainer";
const Definitions = () => {
  return (
    <PageContainer>
      <Typography variant="h4">Definitions</Typography>
      <p>More information coming soon!</p>
    </PageContainer>
  );
};

export default Definitions;
